"use client";

import Cal, { getCalApi } from "@calcom/embed-react";
import { useEffect } from "react";

interface AlignmentCalEmbedProps {
	className?: string;
}

const NAMESPACE = "alignment-call";
const CAL_LINK = "outpace/alignment-call";

export default function AlignmentCalEmbed({
	className,
}: AlignmentCalEmbedProps) {
	useEffect(() => {
		let cancelled = false;

		(async () => {
			try {
				const cal = await getCalApi({ namespace: NAMESPACE });
				if (cancelled) return;
				cal("ui", {
					theme: "dark",
					layout: "month_view",
					hideEventTypeDetails: true,
					cssVarsPerTheme: {
						light: { "cal-brand": "#1A1A1A" },
						dark: { "cal-brand": "#ffffff" },
					},
				});
			} catch (error) {
				// Cal.com handles retries internally; ignore initialization errors silently.
				void error;
			}
		})();

		return () => {
			cancelled = true;
		};
	}, []);

	const containerClassName = [
		"overflow-hidden rounded-[24px] bg-neutral-900 lg:overflow-visible",
		className ?? "w-full",
	]
		.filter(Boolean)
		.join(" ");

	return (
		<div className={containerClassName}>
			<Cal
				namespace={NAMESPACE}
				calLink={CAL_LINK}
				style={{ width: "100%", height: "100%", overflow: "scroll" }}
				config={{ layout: "month_view", theme: "dark" }}
			/>
		</div>
	);
}
